import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchSupportedModels } from "./api";
import type { SupportedModelsResponse } from "./api";

// Список моделей активного провайдера org'а —
// варианты для селектора модели роли. Один на всю страницу (от роли не
// зависит), поэтому key без roleName.
export function useSupportedModels(): UseQueryResult<
  SupportedModelsResponse,
  Error
> {
  return useOrgScopedQuery<SupportedModelsResponse>({
    key: ["agent-roles", "supported-models"],
    queryFn: () => fetchSupportedModels(),
    retry: false,
  });
}
